import React from "react";
import { Box, Grid, Typography, Stack, Paper, Button } from "@mui/material";
import { atgcard } from "../../assets";

const ConnectivityUpgrade = () => {
  return (
    <Box component="section" sx={{ py: 10 }}>
      <Grid container spacing={6} alignItems="center">
        {/* Text */}
        <Grid item xs={12} md={6}>
          <Stack spacing={3}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                color: "#fff",
                fontFamily: "Poppins, sans-serif",
              }}
            >
              ATG Connectivity Without the Factory Price Tag
            </Typography>

            <Typography
              variant="body1"
              sx={{
                maxWidth: 500,
                color: "rgba(226,232,240,0.8)",
              }}
            >
              Most ATG manufacturers charge high monthly fees for remote access.
              Older TLS consoles don’t offer it at all. Fuel Pro upgrades give
              you modern, cloud-connected remote control — without replacing
              your entire system.
            </Typography>

            <Button
              variant="contained"
              color="primary"
              size="large"
              sx={{ mt: 2, fontWeight: 600 }}
              href="#contact"
            >
              Compare Upgrade Options
            </Button>
          </Stack>
        </Grid>

        {/* Image */}
        <Grid item xs={12} md={6}>
          <Paper
            elevation={0}
            sx={{
              borderRadius: 3,
              overflow: "hidden",
              bgcolor: "transparent",
            }}
          >
            <Box
              component="img"
              src={atgcard}
              alt="ATG Upgrade"
              sx={{ width: "100%", objectFit: "cover" }}
            />
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ConnectivityUpgrade;
